import { GameReportBetProps } from '../props';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { Player } from '@/models/player';
import CopyToClipboard from 'react-copy-to-clipboard';
import BetInfoSkeleton from './Skeleton';
import { Image } from '@starsoft/common/components';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';

export default function BetInfo({ bet, isPending }: GameReportBetProps) {
  const { t } = useTranslation('game-report');
  const player: Player | undefined = bet?.player;
  const { NotificationsService } = useNotificationService();

  function handleCopy() {
    NotificationsService.success({
      title: 'copy_base_title',
      message: 'copy_url',
    });
  }

  if (isPending) {
    return <BetInfoSkeleton />;
  }

  return (
    <div className={styles.container}>
      <Image
        className={styles.container__image}
        alt="user profile image"
        src={player?.photo}
        secondarySkeleton
      />

      <div className={styles.container__column}>
        <span className={styles.container__text}>{player?.username}</span>

        <div
          className={`${styles.container__column} ${styles['container__column--small']}`}
        >
          <span
            className={`${styles.container__text} ${styles['container__text--secondary']} ${styles['container__text--small']}`}
          >
            {bet?.createdAt &&
              t('played_at_label', {
                date: Intl.DateTimeFormat('pt-BR', {
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                }).format(new Date(bet?.createdAt)),
              })}
          </span>

          <div className={styles.container__row}>
            <span
              className={`${styles.container__text} ${styles['container__text--secondary']} ${styles['container__text--small']}`}
            >
              {t('game_id_label')}
            </span>

            <i
              className={`${styles['container__text']} ${styles['container__text--success-color']} ${styles['container__text--small']} fa-solid fa-shield-check`}
            />

            <span
              className={`${styles.container__text} ${styles['container__text--small']}`}
            >
              {bet?.id.toString()}
            </span>

            <CopyToClipboard onCopy={handleCopy} text={`${bet?.id}`}>
              {/* @ts-ignore */}
              <i
                className={`${styles['container__text']} ${styles['container__text--copy']} ${styles['container__text--small']} fa-solid fa-copy`}
              />
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  );
}
